import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8ed58c7a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8ed58c7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed58c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ed58c7a')) {
      api.createRecord('8ed58c7a', component.options)
    } else {
      api.reload('8ed58c7a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8ed58c7a&scoped=true", function () {
      api.rerender('8ed58c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/link/generate/index.vue"
export default component.exports